import { useEffect, useState } from 'react';

import { httpGetPortalsByPortalId } from '@iconik-io/iconik-api/src/services/assets';

import { useAppDispatch, useAppSelector } from '../../../redux/redux_hooks';
import { usePlaylist } from './use_playlist';

export const usePortalWithPlaylist = (portalId: string | undefined) => {
  const dispatch = useAppDispatch();
  const portal = useAppSelector((state) =>
    portalId ? state.entities.portals[portalId] : undefined,
  );
  const { entity: playlist, status: playlistStatus } = usePlaylist(
    portal?.playlist_id ?? undefined,
  );
  const [isPortalLoading, setIsPortalLoading] = useState(
    () => Boolean(portalId) && !portal,
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: portal is read on portalId change to decide whether the cache covers the new id; we don't want to re-run when the fetch updates it
  useEffect(() => {
    if (!portalId || portal) {
      setIsPortalLoading(false);
      return;
    }
    let cancelled = false;
    setIsPortalLoading(true);
    dispatch(httpGetPortalsByPortalId(portalId))
      .catch(() => {
        // Swallow: an error leaves `portal` unset, so the not-found state
        // renders instead of an unhandled rejection.
      })
      .finally(() => {
        if (!cancelled) {
          setIsPortalLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [portalId]);

  const isPlaylistLoading =
    Boolean(portal?.playlist_id) && !playlist && playlistStatus === 'pending';

  return { portal, playlist, isLoading: isPortalLoading || isPlaylistLoading };
};
